import {
  FooterContainer,
  Container,
  FooterIcons,
  FooterText,
  Icon,
  Text,
} from "./footer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faMedium,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

export default function Footer() {
  return (
    <FooterContainer>
      <Container>
        <FooterText>
          <Text>Website by Shruti</Text>
          <Text>© {new Date().getFullYear()} Shruti.</Text>
        </FooterText>
        <FooterIcons>
          <Icon
            href="https://github.com/shrued"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faGithub} />
          </Icon>
          <Icon
            href="https://medium.com/@shrued"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faMedium} />
          </Icon>
          <Icon
            href="https://www.linkedin.com/in/shruti-s-099b58169/"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </Icon>
        </FooterIcons>
      </Container>
    </FooterContainer>
  );
}
